module.exports = __webpack_public_path__ + "static/media/logo.7fa85b4c.png";